module.exports = __webpack_public_path__ + "img/ManHoleDownWithFlow.e711a22e.svg";